module.exports = __webpack_public_path__ + "static/img/AB4338774.978c504b.jpg";